import { render } from "./RedirectDomains.vue?vue&type=template&id=139ea18e&scoped=true&ts=true"
import script from "./RedirectDomains.vue?vue&type=script&lang=ts"
export * from "./RedirectDomains.vue?vue&type=script&lang=ts"

import "./RedirectDomains.vue?vue&type=style&index=0&id=139ea18e&scoped=true&lang=scss"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139ea18e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTable});
